import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import styles from './ui-support-icon.css?inline';
import '../ui-sprite-svg/ui-sprite-svg';

const CName = 'ui-support-icon';

@customElement(CName)
export class UISupportIcon extends LitElement {
  static readonly styles = unsafeCSS(styles);

  render() {
    return html`
    <ui-sprite-svg .iconID=${'support-icon'}></ui-sprite-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UISupportIcon;
  }
}
